export enum COUNTER_APP {
  PRACTICE_PROGRAM = 'practice-program',
}
